import { render, staticRenderFns } from "./Segments.vue?vue&type=template&id=c7111aec&scoped=true"
import script from "./Segments.vue?vue&type=script&lang=js"
export * from "./Segments.vue?vue&type=script&lang=js"
import style0 from "./Segments.vue?vue&type=style&index=0&id=c7111aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7111aec",
  null
  
)

export default component.exports